import {useGetSubscribeInfo} from "../../../../hooks/api/Subscribe/useGetSubscribeInfo";
import {FC, useEffect, useState} from "react";
import styled from "styled-components";
import {FlexBox, Skeleton} from "@brg/ui";
import {LayoutConst} from "../../../../../core";
import {useTranslation} from "react-i18next";
import { useTheme } from "styled-components";
import { API, Designer, Endpoints, Status } from "@brg/api";
import { SubscribeController } from "shared/components/Subscribe/SubscribeController";
import { AppTester } from "supporting";
import { ContactButton } from "shared/components/ContactButton/ContactButton";

const InfoBlock = styled.div`
    color: ${({ theme }) => theme.subscribeInfo.color};
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    margin-top: 8px;
    
    display: flex;
    flex-direction: row;
    gap: 8px;

    a {
        text-decoration: none;
        color: ${({ theme }) => theme.subscribeInfo.color};
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        width: fit-content;
        font-size: 13px;
        line-height: 16px;
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
        font-size: 13px;
        line-height: 16px;
        flex-wrap: wrap;
    }
`
const Line = styled.span`
    // margin: 0px 6px;
`;
 

export const SubscribeInfo: FC<{ designer?: Designer<'Local'>, isMe?: boolean, statusTags: Status[], isLoadingStatusTags: boolean }> = ({ designer, isMe, statusTags, isLoadingStatusTags }) => {
    const { i18n: { language }} = useTranslation();
    const {info, isLoading} = useGetSubscribeInfo(designer?.designerId ?? '')
    const [subscribers, setSubscribers] = useState(null);
    const theme = useTheme();
    const { t } = useTranslation()
    
    const getDeclension = (number: number, wordForms: string[]) => {
        const cases = [2, 0, 1, 1, 1, 2];
        return wordForms[
            number % 100 > 4 && number % 100 < 20
                ? 2
                : cases[Math.min(number % 10, 5)]
        ];
    };

    const fetchData = async () => {
        await API
            .request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Designer/GetTabsItemsCount')
            .body({
                tabs: [
                    {
                        entityType: "subscribers",
                        filter: {accountId: designer?.designerId},
                        isOverride: true,
                        name: "subscribers"
                    }
                ]
            })
            .post()
            .release()
            .then((r) => {
                if (r?.tabs && !!r?.tabs?.length) {
                    const count = r?.tabs?.find((i: any) => i?.name === "subscribers")?.count || 0
                    setSubscribers(count)
                }
            });
    }

    useEffect(() => {
        fetchData()
    } , [designer])

    if(!designer) {
        return null
    }

    return ( 
        <>
            {(isLoading) ? (
                <FlexBox direction={'row'} width={'100%'}>
                    <FlexBox gx={24} offsetTop={32}>
                        <Skeleton
                            style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                            width={104}
                            height={22}
                        />
                        {/* <Skeleton
                            style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                            width={104}
                            height={22}
                        /> */}
                        {/* <Skeleton
                            style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                            width={104}
                            height={22}
                        /> */}
                        {/* <Skeleton
                            style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                            width={104}
                            height={22}
                        /> */}
                    </FlexBox>
                </FlexBox>
            ) : (
                <InfoBlock>
                    {!!subscribers && subscribers > 0 && (
                        <>
                            <FlexBox>
                                <span style={{marginRight: '8px'}}>{subscribers|| 0}</span>
                                <span>{getDeclension(subscribers || 0, [t('subscription.subscriber'), t('subscription.subscrib'), t('subscription.subscribers')])}</span>
                            </FlexBox>
                        </>
                    )
                    }
                    {!isMe && (
                        <SubscribeController
                            designer={designer} 
                        />)
                    }
                    {true && <ContactButton statusTags={statusTags} isLoadingStatusTags={isLoadingStatusTags} designerId={designer.designerId} />}
                </InfoBlock>
            )}
        </>
    );
  
}

export default SubscribeInfo;import {useGetSubscribeInfo} from "../../../../hooks/api/Subscribe/useGetSubscribeInfo";
import {FC, useEffect, useState} from "react";
import styled from "styled-components";
import {FlexBox, Skeleton} from "@brg/ui";
import {LayoutConst} from "../../../../../core";
import {useTranslation} from "react-i18next";
import { useTheme } from "styled-components";
import { API, Designer, Endpoints, Status } from "@brg/api";
import { SubscribeController } from "shared/components/Subscribe/SubscribeController";
import { AppTester } from "supporting";
import { ContactButton } from "shared/components/ContactButton/ContactButton";

const InfoBlock = styled.div`
    color: ${({ theme }) => theme.subscribeInfo.color};
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    margin-top: 8px;
    
    display: flex;
    flex-direction: row;
    gap: 8px;

    a {
        text-decoration: none;
        color: ${({ theme }) => theme.subscribeInfo.color};
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        width: fit-content;
        font-size: 13px;
        line-height: 16px;
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
        font-size: 13px;
        line-height: 16px;
        flex-wrap: wrap;
    }
`
const Line = styled.span`
    // margin: 0px 6px;
`;
 

export const SubscribeInfo: FC<{ designer?: Designer<'Local'>, isMe?: boolean, statusTags: Status[], isLoadingStatusTags: boolean }> = ({ designer, isMe, statusTags, isLoadingStatusTags }) => {
    const { i18n: { language }} = useTranslation();
    const {info, isLoading} = useGetSubscribeInfo(designer?.designerId ?? '')
    const [subscribers, setSubscribers] = useState(null);
    const theme = useTheme();
    const { t } = useTranslation()
    
    const getDeclension = (number: number, wordForms: string[]) => {
        const cases = [2, 0, 1, 1, 1, 2];
        return wordForms[
            number % 100 > 4 && number % 100 < 20
                ? 2
                : cases[Math.min(number % 10, 5)]
        ];
    };

    const fetchData = async () => {
        await API
            .request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Designer/GetTabsItemsCount')
            .body({
                tabs: [
                    {
                        entityType: "subscribers",
                        filter: {accountId: designer?.designerId},
                        isOverride: true,
                        name: "subscribers"
                    }
                ]
            })
            .post()
            .release()
            .then((r) => {
                if (r?.tabs && !!r?.tabs?.length) {
                    const count = r?.tabs?.find((i: any) => i?.name === "subscribers")?.count || 0
                    setSubscribers(count)
                }
            });
    }

    useEffect(() => {
        fetchData()
    } , [designer])

    if(!designer) {
        return null
    }

    return ( 
        <>
            {(isLoading) ? (
                <FlexBox direction={'row'} width={'100%'}>
                    <FlexBox gx={24} offsetTop={32}>
                        <Skeleton
                            style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                            width={104}
                            height={22}
                        />
                        {/* <Skeleton
                            style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                            width={104}
                            height={22}
                        /> */}
                        {/* <Skeleton
                            style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                            width={104}
                            height={22}
                        /> */}
                        {/* <Skeleton
                            style={{ backgroundColor: theme.skeleton.skeletonBgColor }}
                            width={104}
                            height={22}
                        /> */}
                    </FlexBox>
                </FlexBox>
            ) : (
                <InfoBlock>
                    {!!subscribers && subscribers > 0 && (
                        <>
                            <FlexBox>
                                <span style={{marginRight: '8px'}}>{subscribers|| 0}</span>
                                <span>{getDeclension(subscribers || 0, [t('subscription.subscriber'), t('subscription.subscrib'), t('subscription.subscribers')])}</span>
                            </FlexBox>
                        </>
                    )
                    }
                    {!isMe && (
                        <SubscribeController
                            designer={designer} 
                        />)
                    }
                    {true && <ContactButton statusTags={statusTags} isLoadingStatusTags={isLoadingStatusTags} designerId={designer.designerId} />}
                </InfoBlock>
            )}
        </>
    );
  
}

export default SubscribeInfo;